import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FieldSelector from 'components/FieldSelector/FieldSelector';

var AssetType = function (props) {
  var config = props.config;
  var settingsFields = props.settingsFields;
  var errors = props.errors || {};
  var t = useTranslation().t;

  var handleFieldChange = function (suuid, title) {
    props.onAssetTypeFieldChange(suuid, title);
  };

  var handleValueChange = function (e) {
    props.onAssetTypeValueChange(e.target.value);
  };

  return (
    <div className="inspect-section-asset-type">
      <div className="inspect-settings-content-header">
        <h3 className="inspect-settings-content-title">{t('inspect:sectionAssetType')}</h3>
        <p className="inspect-settings-content-description">{t('inspect:assetTypeDescription')}</p>
      </div>
      <FieldSelector
        currentSUUID={config.assetTypeFieldKey || ''}
        fields={settingsFields}
        onChange={handleFieldChange}
        filterType="selector"
        error={!!errors.assetTypeFieldPathHash}
      />
      {errors.assetTypeFieldPathHash && (
        <div className="slate-text-input-error">{errors.assetTypeFieldPathHash}</div>
      )}
      <div className="inspect-recurrence-field">
        <label className="inspect-recurrence-label">{t('inspect:assetTypeValueLabel')}</label>
        <input
          type="text"
          className={'inspect-recurrence-number' + (errors.assetTypeValue ? ' has-error' : '')}
          value={config.assetTypeValue || ''}
          onChange={handleValueChange}
          disabled={!config.assetTypeFieldKey}
          style={{ width: '100%' }}
        />
        <p className="inspect-mode-hint">
          {!config.assetTypeFieldKey
            ? t('inspect:assetTypeValueDisabledHint')
            : t('inspect:assetTypeValueHint')}
        </p>
        {errors.assetTypeValue && (
          <div className="slate-text-input-error">{errors.assetTypeValue}</div>
        )}
      </div>
    </div>
  );
};

AssetType.propTypes = {
  config: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  settingsFields: PropTypes.array.isRequired,
  onAssetTypeFieldChange: PropTypes.func.isRequired,
  onAssetTypeValueChange: PropTypes.func.isRequired,
};

export default AssetType;
